import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import EditIcon from "@mui/icons-material/Create";
import IconButton from "@mui/material/IconButton";

import { BILLING_LEDGER_ENTRIES_PATH } from "../../../constants/router";

export const headRows = translate => [
  { id: "conferenceId", numeric: false, disablePadding: true, label: translate.conferenceId },
  { id: "startTime", numeric: false, disablePadding: false, label: translate.confStartTime },
  { id: "endTime", numeric: false, disablePadding: false, label: translate.confEndTime },
  { id: "quantity", numeric: true, disablePadding: false, label: translate.quantity },
  { id: "name", numeric: false, disablePadding: false, label: translate.name },
  { id: "requestFrom", numeric: false, disablePadding: false, label: translate.requestFrom },
  { id: "userName", numeric: false, disablePadding: false, label: translate.participantName },
  { id: "bPhoneNo", numeric: false, disablePadding: false, label: translate.bPhoneNumber },
  { id: "contractNo", numeric: false, disablePadding: false, label: translate.contractNumber },
  { id: "stat", numeric: false, disablePadding: false, label: translate.status },
  { id: "errorCode", numeric: false, disablePadding: false, label: translate.errorCodeLedgerEntry },
];

const smallCellSx = { p: "5px" };

const BillingLedgerEntryTableRowTableRow = ({ row, isItemSelected, labelId, handleClick }) => {
  return (
    <TableRow hover role="checkbox" aria-checked={isItemSelected} tabIndex={-1} selected={isItemSelected}>
      <TableCell sx={{ minWidth: "100px", p: "5px" }} padding="checkbox">
        <Checkbox
          onClick={event => handleClick(event, row.selectIndex)}
          checked={isItemSelected}
          slotProps={{ input: { "aria-labelledby": labelId } }}
        />
        <NavLink style={{ color: "inherit", textDecoration: "none" }} to={`${BILLING_LEDGER_ENTRIES_PATH}/${row.id}`}>
          <IconButton sx={theme => ({ mx: 1, maxHeight: "48px" })} size="large">
            <EditIcon />
          </IconButton>
        </NavLink>
      </TableCell>
      <TableCell /* component="th" */ id={labelId} scope="row" padding="none">
        {row.conferenceId}
      </TableCell>
      <TableCell sx={smallCellSx} align="right">
        {row.startTimeString}
      </TableCell>
      <TableCell sx={smallCellSx} align="right">
        {row.endTimeString}
      </TableCell>
      <TableCell sx={smallCellSx} align="right">
        {row.quantity}
      </TableCell>
      <TableCell sx={smallCellSx} align="right">
        {row.name}
      </TableCell>
      <TableCell sx={smallCellSx} align="right">
        {row.requestFrom}
      </TableCell>
      <TableCell sx={smallCellSx} align="right">
        {row.userName}
      </TableCell>
      <TableCell sx={smallCellSx} align="right">
        {row.bPhoneNo}
      </TableCell>
      <TableCell sx={smallCellSx} align="right">
        {row.contractNo}
      </TableCell>
      <TableCell sx={smallCellSx} align="right">
        {row.stat}
      </TableCell>
      <TableCell sx={smallCellSx} align="right">
        {row.errorCode}
      </TableCell>
    </TableRow>
  );
};

BillingLedgerEntryTableRowTableRow.propTypes = {
  row: PropTypes.object.isRequired,
  isItemSelected: PropTypes.bool.isRequired,
  labelId: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default BillingLedgerEntryTableRowTableRow;
